import { SET_IS_OPEN_MODAL } from '../actionTypes';
import { createProjectModalActions } from '../reducer';

export default (isOpen) => createProjectModalActions[SET_IS_OPEN_MODAL](isOpen);
